"use client";

import { motion } from "framer-motion";
import Image from "next/image";

const team = [
  {
    name: "Lucas Ferreira",
    role: "CEO & Estrategista",
    photo: "/team-1.png",
    description:
      "Especialista em posicionamento de marca e planejamento estratégico. Mais de 5 anos transformando negócios através do digital.",
  },
  {
    name: "Rafael Oliveira",
    role: "Head de Tráfego",
    photo: "/team-2.png",
    description:
      "Expert em Meta Ads e Google Ads com histórico comprovado de ROI. Já gerenciou mais de R$ 2M em investimento em mídia paga.",
  },
  {
    name: "Gabriel Santos",
    role: "Diretor Criativo",
    photo: "/team-3.png",
    description:
      "Responsável por branding, design e conteúdo de alto impacto. Une criatividade e dados para construir marcas memoráveis.",
  },
];

export function Team() {
  return (
    <section id="team" className="py-24 relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-[#C9956B]/40 to-transparent" />

      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center max-w-2xl mx-auto mb-8">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[12px] font-medium uppercase tracking-widest text-[#D4A574] mb-4 block"
          >
            Quem Somos
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold tracking-tight mb-4"
          >
            As mentes por trás da Aura
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-[15px] text-zinc-400 leading-relaxed"
          >
            Somos um time apaixonado por resultados reais. Unimos estratégia,
            criatividade e performance para elevar marcas ao próximo nível no
            ambiente digital. Cada projeto é tratado como nosso próprio negócio.
          </motion.p>
        </div>

        {/* Company story block */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="max-w-3xl mx-auto mb-16 text-center"
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#C9956B]/30" />
            <span className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#9e8b7a]">
              Nossa História
            </span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#C9956B]/30" />
          </div>
          <p className="text-[14px] text-zinc-500 leading-relaxed max-w-2xl mx-auto">
            A Aura Digital nasceu da convicção de que toda marca merece brilhar
            no digital. Após anos escalando nossos próprios projetos e validando
            estratégias com investimento real, decidimos compartilhar nossa
            expertise. Hoje, combinamos posicionamento estratégico, presença
            digital consistente e foco absoluto em resultados para transformar
            negócios em referências de mercado.
          </p>
        </motion.div>

        {/* Team grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.12 }}
              className="group text-center"
            >
              {/* Photo */}
              <div className="relative w-40 h-40 mx-auto mb-5 rounded-2xl overflow-hidden border-2 border-white/[0.06] group-hover:border-[#C9956B]/30 transition-all duration-500">
                <Image
                  src={member.photo}
                  alt={member.name}
                  fill
                  className="object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Subtle gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/40 via-transparent to-transparent" />
              </div>

              {/* Name */}
              <h3 className="text-[16px] font-semibold text-white mb-1">
                {member.name}
              </h3>

              {/* Role */}
              <p className="text-[12px] font-medium uppercase tracking-widest text-[#C9956B] mb-3">
                {member.role}
              </p>

              {/* Description */}
              <p className="text-[13px] text-zinc-500 leading-relaxed max-w-[260px] mx-auto">
                {member.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
